<template>
  <page subpage title="Equipment Types">
    <template #actions>
      <div class="flex flex-wrap gap-3 items-end">
        <toggle-switch
          v-model="active"
          label-on="Active"
          label-off="All"
          class="mr-3 mb-2"
        />
        <Select
          :value="componentTypeIds"
          name="ComponentTypes"
          placeholder="All"
          :options="componentTypeOptions"
          label="Component Types"
          class="mr-4"
          :style="{ minWidth: '180px' }"
          multiple
          @update:modelValue="onComponentTypesInput"
        />
        <div class="d-flex align-items-center">
          <sera-button
            icon="fa-solid fa-plus"
            text="Add Equipment Type"
            data-cy="add-equipment-type"
            @click="toggleModal"
          />
        </div>
      </div>
    </template>
    <div>
      <equipment-types-list
        :include-archived="!active"
        :include-component-type-ids="componentTypeIds"
        @edit="handleEdit"
      />
      <equipment-type-modal
        v-if="modalOpen"
        :equipment-type="selectedEquipmentType"
        @hide-modal="toggleModal"
      />
    </div>
  </page>
</template>

<script>
import sortBy from "lodash/sortBy";
import { mapState } from "vuex";
import { getQueryVariables, updateQueryParam } from "@/lib/url.js";

import SeraButton from "@/components/Button.vue";
import Page from "@/components/Page.vue";
import ToggleSwitch from "@/components/ToggleSwitch.vue";
import EquipmentTypeModal from "@/EquipmentTypes/EquipmentTypeModal.vue";
import EquipmentTypesList from "@/EquipmentTypes/EquipmentTypesList.vue";

export default {
  components: {
    EquipmentTypeModal,
    EquipmentTypesList,
    Page,
    ToggleSwitch,
    SeraButton
  },
  data() {
    return {
      mounted: false,
      selectedEquipmentType: null,
      active: true,
      componentTypeIds: [],
      modalOpen: false
    };
  },
  computed: {
    ...mapState(["componentTypes"]),
    componentTypeOptions() {
      return sortBy(
        this.componentTypes.map((item) => {
          return {
            value: item.id,
            label: item.name
          };
        }),
        (option) => (option.label || "").toLowerCase()
      );
    }
  },
  async beforeMount() {
    this.refreshComponentIds();
  },
  mounted() {
    window.addEventListener("popstate", this.refreshComponentIds);
  },
  beforeUnmount() {
    window.removeEventListener("popstate", this.refreshComponentIds);
  },
  methods: {
    handleEdit(equipmentType) {
      this.selectedEquipmentType = equipmentType;
      this.toggleModal();
    },

    // TODO: We need to update the select search for multiselect to not return null (needs to be empty list)
    onComponentTypesInput(val) {
      if (val === null) {
        this.componentTypeIds = [];
        return;
      }
      this.componentTypeIds = val;
    },
    toggleModal() {
      this.modalOpen = !this.modalOpen;
      if (!this.modalOpen) {
        this.selectedEquipmentType = null;
      }
    },
    refreshComponentIds() {
      const { component_type_ids } = getQueryVariables();
      if (component_type_ids !== undefined) {
        this.componentTypeIds = [parseInt(component_type_ids)];
      } else {
        this.componentTypeIds = [];
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
